import { InjectionToken } from '@angular/core';
import { CookiesStatic } from 'js-cookie';

export const COOKIE_SERVICE = new InjectionToken<CookiesStatic>(
  'COOKIE_SERVICE'
);
